export const ADD_BREADCRUMB = 'ADD_BREADCRUMB'
export const REMOVE_BREADCRUMB = 'REMOVE_BREADCRUMB'
export const REPLACE_BREADCRUMBS = 'REPLACE_BREADCRUMBS'
